import Icon from '@forwardflow/ui/Icons'
import { Link, useParams, useSearchParams } from 'react-router-dom'

export const TopBarIdle = () => {
   const { title } = useParams()
   const [searchParams] = useSearchParams()
   const campaignName = searchParams.get('campaignName')

   return (
      <div className="bg-[#9061DA]/[0.05] h-[60px] rounded-xl flex items-center px-2">
         <Link
            to="/campaign"
            className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors shrink-0"
         >
            <Icon
               name="arrow-right"
               className="rotate-180 fill-white"
               width={18}
               height={18}
            />
         </Link>

         <nav className="flex items-center text-sm ml-3">
            <Link to="/dashboard" className="text-white/30 hover:text-white/50 transition-colors">
               Home
            </Link>
            <span className="text-white/20 mx-2">/</span>
            <Link to="/campaign" className="text-white/30 hover:text-white/50 transition-colors">
               Campaign
            </Link>
            {(campaignName || title) && (
               <>
                  <span className="text-white/20 mx-2">/</span>
                  <span className="text-white font-medium truncate max-w-[200px]">
                     {campaignName || title}
                  </span>
               </>
            )}
            <span className="text-white/20 mx-2">/</span>
            <span className="text-white font-medium">Activate</span>
         </nav>
      </div>
   )
}
